// extracted by mini-css-extract-plugin
module.exports = {"searchBox":"SearchBar_searchBox__3It0z","searchBar":"SearchBar_searchBar__1qene"};